import { createSlice } from "@reduxjs/toolkit";
import { postCustomerList, postCustomerCount, getAllCustomers, getCustomersPag } from "./thunks";
import { logOut } from "../authentication/authenticationSlice";

const initialState = {
  list: {
    pageIndex: 0,
    totalRecords: 50,
    totalPages: 1,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: [],
  },
  customersPag: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: [],
  },
  allCustomers: [],
  loading: "idle",
  loadingPag: "idle",
  loadingCount: "idle",
  error: null,
};

const customerSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    clearCustomerError: (state) => {
      state.error = null;
      state.loadingPag = "idle";
    },
    setCustomerFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
  extraReducers: {
    [postCustomerList.pending]: (state) => {
      state.loading = "loading";
      state.error = null;
    },
    [postCustomerList.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.list.elements = action.payload.elements;
    },
    [postCustomerList.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [postCustomerCount.pending]: (state) => {
      state.loadingCount = "loading";
      state.error = null;
    },
    [postCustomerCount.fulfilled]: (state, action) => {
      state.loadingCount = "succeeded";
      state.list.pageIndex = action.payload.pageIndex;
      state.list.totalRecords = action.payload.totalRecords;
      state.list.totalPages = action.payload.totalPages;
      state.list.hasPreviousPage = action.payload.hasPreviousPage;
      state.list.hasNextPage = action.payload.hasNextPage;
    },
    [postCustomerCount.rejected]: (state, action) => {
      state.loadingCount = "failed";
      state.error = action.error.message;
    },
    [getAllCustomers.pending]: (state) => {
      state.loadingAll = "loading";
    },
    [getAllCustomers.fulfilled]: (state, action) => {
      state.loadingAll = "succeeded";
      state.allCustomers = action.payload;
    },
    [getAllCustomers.rejected]: (state, action) => {
      state.loadingAll = "failed";
      state.error = action.error.message;
    },
    [getCustomersPag.pending]: (state) => {
      state.loadingPag = "loading";
      state.error = null;
    },
    [getCustomersPag.fulfilled]: (state, action) => {
      state.loadingPag = "succeeded";
      state.customersPag.elements = action.payload.elements;
      state.customersPag.pageIndex = action.payload.pageIndex;
      state.customersPag.pageSize = action.payload.pageSize;
      state.customersPag.totalRecords = action.payload.totalRecords;
      state.customersPag.totalPages = action.payload.totalPages;
      state.customersPag.hasPreviousPage = action.payload.hasPreviousPage;
      state.customersPag.hasNextPage = action.payload.hasNextPage;
    },
    [getCustomersPag.rejected]: (state, action) => {
      state.loadingPag = "failed";
      state.error = action.error ? action.error.message : "Error";
    },
  },
  [logOut]: (state) => initialState,
});

export const { clearCustomerError, setCustomerFilters } = customerSlice.actions;

export default customerSlice.reducer;
